import React from "react";
import { IconSize, TextColor } from "@twilio-paste/style-props";

export const APP_TITLE = "Consulcesi | WhatsHelp";

interface LogoTwilioIconProps {
  decorative?: boolean;
  color?: TextColor | undefined;
  size?: IconSize | undefined;
  title?: string;
}

const PHONE_NUMBER_DISPLAY = process.env.REACT_APP_WHATSAPP_NUMBER;

export const AppLogo: React.FC<LogoTwilioIconProps> = () => (
  <a
    aria-label={`Numero Whatsapp ${PHONE_NUMBER_DISPLAY}`}
    title={`Numero Whatsapp ${PHONE_NUMBER_DISPLAY}`}
    style={{
      display: "inline-block",
      cursor: "pointer",
    }}
  >
    <img
      src="/assets/logo-consulcesi.svg"
      alt="Logo Consulcesi"
      style={{
        display: "block",
        height: 50,
        width: "auto",
      }}
    />
  </a>
);
